var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaves(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.415,46.54l12.248-7.964L46.91,46.54c0.663,0.431,1.518,0.431,2.18,0l12.248-7.964l12.247,7.964 c0.336,0.219,0.714,0.323,1.088,0.323c0.654,0,1.295-0.32,1.679-0.91c0.603-0.926,0.34-2.165-0.587-2.767l-13.337-8.673 c-0.661-0.43-1.517-0.431-2.18,0L48,42.478l-12.247-7.964c-0.663-0.431-1.518-0.431-2.181,0l-13.338,8.673 c-0.926,0.602-1.188,1.841-0.586,2.767C20.25,46.879,21.488,47.142,22.415,46.54z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.765,58.133L62.428,49.46c-0.661-0.431-1.517-0.433-2.18,0L48,57.424L35.753,49.46c-0.663-0.432-1.518-0.432-2.181,0 l-13.338,8.673c-0.926,0.603-1.188,1.841-0.586,2.767c0.383,0.59,1.024,0.91,1.679,0.91c0.374,0,0.751-0.104,1.088-0.323 l12.248-7.964l12.247,7.964c0.663,0.432,1.518,0.432,2.18,0l12.248-7.964l12.247,7.964c0.923,0.602,2.164,0.34,2.767-0.587 C76.954,59.974,76.691,58.735,75.765,58.133z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaves);
export default __webpack_public_path__ + "static/media/waves.9f9434411ba2614677b0058651ce25ba.svg";
export { ForwardRef as ReactComponent };